import config from "@/config";
import { PaymentSystem } from "@teacherskaya/api-provider/dist/api/PaymentSystemsProvider";

export const isTestPaymentSystem = (system: PaymentSystem) =>
  system.type === config.testPaymentSystem.type;

export const isDraftPaymentSystem = (system: PaymentSystem) => system.currencies.length === 0;
